// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice--1piFn","title":"title--3a1JN","red":"red--1DKPw","blue":"blue--3EzOP","wrap":"wrap--1_luv","content":"content--38Xg_","more":"more--3_Bki"};